// extracted by mini-css-extract-plugin
module.exports = {"drawer":"IKyZl","drawerContent":"_18Lbf"};